var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41893 8.08293C9.80986 8.47404 9.80986 9.10594 9.41893 9.49706C9.22392 9.69206 8.96794 9.79002 8.71178 9.79002C8.4558 9.79002 8.19981 9.69206 8.00481 9.49706L4.99986 6.49193L1.99492 9.49706C1.79991 9.69206 1.54393 9.79002 1.28795 9.79002C1.03178 9.79002 0.775803 9.69206 0.580795 9.49706C0.189865 9.10594 0.189865 8.47404 0.580795 8.08293L3.58592 5.07799L0.580795 2.07304C0.189865 1.68193 0.189865 1.05003 0.580795 0.65892C0.971909 0.26799 1.60381 0.26799 1.99492 0.65892L4.99986 3.66405L8.00481 0.65892C8.39592 0.26799 9.02782 0.26799 9.41893 0.65892C9.80986 1.05003 9.80986 1.68193 9.41893 2.07304L6.4138 5.07799L9.41893 8.08293Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ad7802d4dd8fd21c1a6909837172eea3.svg";
export { ForwardRef as ReactComponent };